enum UsageTypes {
    not_used= "not used",
    used_visiting = "used, visiting site",
    used_worship = "used, worship site",
    used_office = "used, office use",
    used_other = "other use"
  }
  
  export default UsageTypes;